// @ts-nocheck
/** MI DOMINO - identity/profile. */
import { saveAdminDB } from '../admin/portal';
import { ONLINE_MODE, RANK_COLORS } from '../data/config';
import { isPro, pullCollectible, revealCollectible } from '../economy/tienda';
import { L, earnCoins, fanReact } from '../game/engine';
import { questsTick } from '../economy/quests';
import { achTick } from './achievements';
import { rankInfo } from './ranks';
import { ACCOUNT, ADMIN_DB, API_TOKEN, NET, PROFILE, STATS, TEAM, WALLET, cloudT, setCloudT } from '../state';
import { banner } from '../ui/banner';
import { log } from '../ui/feed';
import { LANG, t } from '../ui/i18n';
import { api } from '../net/api';
import { syncFeltSelect, syncSkinSelect, syncWoodSelect } from '../economy/wallet';

export function upsertSelfUser() {
  if (!ACCOUNT.email) return;
  if (!ACCOUNT.joined) ACCOUNT.joined = Date.now();
  saveAccount();
  const r = rankInfo();
  const me = {
    name: ACCOUNT.fullname || PROFILE.name || L('Jugador', 'Player'), email: ACCOUNT.email, phone: ACCOUNT.phone || '', country: PROFILE.country,
    rank: r.idx + 1, pro: WALLET.pro ? WALLET.pro.plan : null,
    spend: ADMIN_DB.sales.filter(s => !s.demo).reduce((a, s) => a + s.usd, 0),
    joined: ACCOUNT.joined, pay: ACCOUNT.pay || null, demo: false,
  };
  const i = ADMIN_DB.users.findIndex(u => !u.demo);
  if (i >= 0) ADMIN_DB.users[i] = me; else ADMIN_DB.users.unshift(me);
  saveAdminDB();
}

export function teamCode() {
  if (!TEAM.code) {
    const base = (TEAM.name || 'EQUIPO').replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 4).padEnd(4, 'X');
    TEAM.code = base + '-' + Math.random().toString(36).replace(/[^a-z0-9]/g, '').slice(0, 4).toUpperCase();
    try { localStorage.setItem('team', JSON.stringify(TEAM)); } catch (e) {}
  }
  return TEAM.code;
}

export function saveStats() {
  try { localStorage.setItem('stats', JSON.stringify(STATS)); } catch (e) {}
  cloudSync();   // stats follow the account too (wallet saves already do)
  try { questsTick(); } catch (e) { /* missions must never break a save */ }   // 🎯 pay out completed missions
  try { achTick(); } catch (e) { /* achievements must never break a save */ }  // 🏅 pay out newly earned badges
}

export function applyProfile() {
  const tl = document.getElementById('team-label');
  if (tl) tl.textContent = TEAM.name ? `${TEAM.flag} ${TEAM.name.toUpperCase().slice(0, 12)}` : t('us');
  const av = document.querySelector('#me-info .cam span');
  if (av) {
    if (PROFILE.photo) {
      av.innerHTML = `<img src="${PROFILE.photo}" style="width:272px;height:153px;object-fit:cover;border-radius:7px">`;
    } else {
      av.textContent = PROFILE.avatar || '🔥';
    }
  }
  const n0 = document.getElementById('name0');
  if (n0 && !NET.active) n0.textContent = PROFILE.name ? `${PROFILE.country} ${PROFILE.name}` : t('you');
}

export function addXP(n, why) {
  /* FREE tier: rank progression is a PRO CLUB privilege */
  if (!isPro()) {
    const now = Date.now();
    if (!window._xpHint || now - window._xpHint > 60000) {
      window._xpHint = now;
      log(LANG === 'en'
        ? '🔒 Ranking up is a PRO CLUB privilege — your XP is waiting for you.'
        : '🔒 Subir de rango es privilegio del PRO CLUB — tu XP te está esperando.', true);
    }
    return;
  }
  const before = rankInfo().idx;
  STATS.xp = (STATS.xp || 0) + n;
  saveStats();
  log(`+${n} XP — ${why}`);
  const after = rankInfo();
  if (after.idx > before) {
    const rn = LANG === 'en' ? after.eng : after.name;   // rank title in the active language
    banner(LANG === 'en' ? `NEW RANK! ${after.emoji} ${rn.toUpperCase()}` : `¡RANGO NUEVO! ${after.emoji} ${rn.toUpperCase()}`);
    earnCoins(50 + after.idx * 25, LANG === 'en' ? `promoted to ${rn} ${after.emoji}` : `ascendiste a ${rn} ${after.emoji}`);
    fanReact('🎉');
    /* rank-up drops a collectible — higher rank, better rarity guaranteed */
    const minR = after.idx >= 9 ? 4 : after.idx >= 6 ? 3 : after.idx >= 3 ? 2 : 1;
    setTimeout(() => {
      revealCollectible(pullCollectible(minR),
        LANG === 'en' ? `Rank-up drop: ${after.emoji} ${after.eng}` : `Ficha de ascenso: ${after.emoji} ${after.name}`);
    }, 2300);
  }
  updateRankBadge();
}

export function updateRankBadge() {
  const r = rankInfo();
  const b = document.getElementById('my-rank-badge');
  if (!b) return;
  const col = RANK_COLORS[r.idx] || '#f0b429';
  b.innerHTML = `<span class="g">${r.emoji}</span><span>${LANG === 'en' ? r.eng : r.name}${isPro() ? '' : ' 🔒'}</span>`;
  b.style.borderColor = col;
  try {
    const cam = document.querySelector('#me-info .cam');
    if (cam) cam.style.boxShadow = `0 6px 14px rgba(0,0,0,.55), 0 0 16px ${col}66`;
  } catch (e) {}
}

export function hydrateState(st) {
  if (!st) return;
  try {
    if (st.wallet) localStorage.setItem('wallet', JSON.stringify(st.wallet));
    if (st.stats) localStorage.setItem('stats', JSON.stringify(st.stats));
    if (st.profile) localStorage.setItem('profile', JSON.stringify(st.profile));
    if (st.team) localStorage.setItem('team', JSON.stringify(st.team));
  } catch (e) {}
}

/** The server unions purchases across devices (a stale device never wipes what
 *  another one bought). Whatever it hands back that this device lacks is
 *  adopted on the spot — no reload — and the ⚙️ lists follow. */
export function adoptCloudWallet(sw) {
  if (!sw || typeof sw !== 'object') return false;
  const owned = Array.isArray(sw.owned) ? sw.owned : [];
  const missing = owned.filter((id) => !WALLET.owned.includes(id));
  const collect = Array.isArray(sw.collect) ? sw.collect : [];
  const key = (c) => `${c.id}#${c.serial ?? ''}`;
  const have = new Set(WALLET.collect.map(key));
  const missingC = collect.filter((c) => !have.has(key(c)));
  if (!missing.length && !missingC.length) return false;
  WALLET.owned.push(...missing);
  WALLET.collect.push(...missingC);
  try { localStorage.setItem('wallet', JSON.stringify(WALLET)); } catch (e) {}
  try { syncSkinSelect(); syncFeltSelect(); syncWoodSelect(); } catch (e) {}
  return true;
}

export function cloudSync() {
  if (!ONLINE_MODE || !API_TOKEN) return;
  clearTimeout(cloudT);
  setCloudT(setTimeout(() => {
    api('/api/state', { wallet: WALLET, stats: STATS, profile: PROFILE, team: TEAM })
      .then((r) => { if (r && r.state) adoptCloudWallet(r.state.wallet); })
      .catch(() => {});
  }, 1500));
}

/** On load, signed in: pull what other devices bought since this one last synced. */
export function pullCloudWallet() {
  if (!ONLINE_MODE || !API_TOKEN) return;
  api('/api/me').then((r) => { if (r && r.state) adoptCloudWallet(r.state.wallet); }).catch(() => {});
}

/** Persist the account locally and (when signed in online) to the cloud. */
export function saveAccount() {
  try { localStorage.setItem('account', JSON.stringify(ACCOUNT)); } catch (e) {}
  cloudSync();
}

/** Periodic + on-hide cloud sync (every wallet/account/stats save also syncs). */
export function initCloudSync() {
  pullCloudWallet();
  setInterval(() => cloudSync(), 45000);
  document.addEventListener('visibilitychange', () => { if (document.hidden) cloudSync(); });
}

/** One-time upgrades of stats saved by older builds: incremental XP, streaks,
 *  online hands (missions). Must run before the missions take their baseline. */
export function migrateStats() {
  if (typeof STATS.xp !== 'number') {
    STATS.xp = STATS.handsWon * 10 + STATS.matchesWon * 50 + STATS.capicus * 25 + STATS.chuchazos * 40 + STATS.tranquesWon * 15;
  }
  if (typeof STATS.streak !== 'number') STATS.streak = 0;
  if (typeof STATS.onlineHands !== 'number') STATS.onlineHands = 0;   // 🌐 online hands played (missions)
  if (typeof STATS.bestStreak !== 'number') STATS.bestStreak = 0;
}
